var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechJwt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_3721)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8 27.1998L57.7 0.299805H42.7L42.8 27.1998L50.3 37.4998L57.8 27.1998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8 73.3V100.3H57.8V73.3L50.3 63L42.8 73.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8 73.2996L73.6 95.0996L85.7 86.2996L69.9001 64.4996L57.8 60.5996V73.2996Z",
    fill: "#00F2E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8 27.1994L26.9 5.39941L14.8 14.1994L30.6 35.9994L42.8 39.8994V27.1994Z",
    fill: "#00F2E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6 36.0002L5.00002 27.7002L0.400024 41.9002L26 50.3002L38.1 46.3002L30.6 36.0002Z",
    fill: "#00B9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4 54.1998L69.9 64.4998L95.5 72.7998L100.1 58.5998L74.5 50.2998L62.4 54.1998Z",
    fill: "#00B9F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5 50.3002L100.1 41.9002L95.5 27.7002L69.9 36.0002L62.4 46.3002L74.5 50.3002Z",
    fill: "#D63AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 50.2998L0.400024 58.5998L5.00002 72.7998L30.6 64.4998L38.1 54.1998L26 50.2998Z",
    fill: "#D63AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6 64.4996L14.8 86.2996L26.9 95.0996L42.8 73.2996V60.5996L30.6 64.4996Z",
    fill: "#FB015B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9001 35.9994L85.7 14.1994L73.6 5.39941L57.8 27.1994V39.8994L69.9001 35.9994Z",
    fill: "#FB015B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_3721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 101,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechJwt);
export default __webpack_public_path__ + "static/media/tech-jwt.92f4abb36507ccc245e724aa4d20a3bd.svg";
export { ForwardRef as ReactComponent };